/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useState, useEffect } from "react"
import { Container, Row } from "react-bootstrap"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import "bootstrap/dist/css/bootstrap.min.css"
import { cashFlowGeneral, cashFlowGeneralByDimension, getProjetsByCompanyByDimensionRequest, getProjetsByCompanyRequest, resetCashFlowGeneral, resetProjetsByCompanyRequest } from "../../actions/cash-flow.action"
import { useDispatch } from "react-redux"
import InputsGroup from "./InputsGroup"
import ChartAndTable from "./ChartAndTable"


ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend)

const CashFlowPD = () => {
  const dispatch = useDispatch();

  const [selectedCoin, setSelectedCoin] = useState("PEN")
  const [selectedCompany, setSelectedCompany] = useState("")
  const [mode, setMode] = useState("-1")
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [period, setPeriod] = useState("0")
  const [selectedProject, setSelectedProject] = useState('');

  useEffect(() => {
    if (!endDate) {
      return
    }
    dispatch(resetProjetsByCompanyRequest())
    setSelectedProject('')
    if (mode === '-1') {
      getProjetsByCompanyRequest(selectedCompany, startDate, endDate);
    } else {
      getProjetsByCompanyByDimensionRequest(selectedCompany, startDate, endDate, mode);
    }
  }, [selectedCompany, startDate, endDate, mode])

  useEffect(() => {
    if (!endDate) {
      return
    }
    dispatch(resetCashFlowGeneral())
    if (mode === '-1') {
      cashFlowGeneral(startDate, endDate, selectedCompany, selectedProject, period)
    } else {
      cashFlowGeneralByDimension(startDate, endDate, selectedCompany, period, mode, selectedProject);
    }
  }, [selectedCompany, startDate, endDate, period, selectedProject, mode])

  return (
    <Container fluid className="p-3 d-flex flex-column" style={{ height: '90vh' }}>
      <InputsGroup
        selectedCoin={selectedCoin}
        setSelectedCoin={setSelectedCoin}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        mode={mode}
        setMode={setMode}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        period={period}
        setPeriod={setPeriod}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
      />

      <Row className="flex-grow-1 position-relative" style={{ minHeight: '0' }}>
        <ChartAndTable
          startDate={startDate}
          endDate={endDate}
          selectedCoin={selectedCoin}
        />
      </Row>
    </Container>
  )
}

export default CashFlowPD